module.exports = __webpack_public_path__ + "img/progress_mobile@2x.6749dbec.png";